import { makeRequestAuth } from "../utils/globals";

class PaymentService {
  /*
   * @param  filters
   * @returns {promise}
   * returns details of sales order
   */
  createPayuRechargeOrder = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "storesAdmin.mutation.rechargeOrder",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  calculateAmount = (params, signal = false) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "storesAdmin.mutation.calculateAmount",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(
        request_data,
        (response) => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            resolve({});
          }
        },
        "",
        "",
        signal
      );
    });
  };

  getPGs = (params, signal = false) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.query.getPGs",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(
        request_data,
        (response) => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            resolve({});
          }
        },
        "",
        "",
        signal
      );
    });
  };
  
  getPaymentStatus = (params, signal = false) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.query.getPaymentStatus",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(
        request_data,
        (response) => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            resolve({});
          }
        },
        "",
        "",
        signal
      );
    });
  };

  createSalesOrder = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.createSalesOrder",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  createRazorpaySalesOrder = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.createSalesOrder",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  updateRazorpayPaymentSuccess = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.updatePaymentSuccess",
        tag: "payemnt",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  updateRazorpayPaymentFail = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.updatePaymentFail",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  createPrimerSalesOrder = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.createSalesOrder",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  updatePrimerPayment = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.updatePayment",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  createStripeSalesOrder = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.createSalesOrder",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  updateStripePayment = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.updatePayment",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  createPayoneerSalesOrder = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.mutation.createSalesOrder",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  checkPayoneerPaymentSuccess = (params) => {
    return new Promise((resolve) => {
      const request_data = {
        query: "payment.query.getPaymentStatus",
        tag: "payment",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };
}

export default new PaymentService();
